const axios = require('axios');

let localUrlModuleApi = 'http://teamhive-management.test:8000/api/Url/Url/';
let prodUrlModuleApi = 'https://manage.teamhive.live/api/Url/Url/';
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = localUrlModuleApi;
} else {
  axios.defaults.baseURL = prodUrlModuleApi;
}

export function saveCategoriesPlugin(store) {
  store.subscribe((mutation, state) => {
    localStorage.setItem('categories', JSON.stringify(state.categories));
  });
}

export function saveDashboardConfigPlugin(store) {
  store.subscribe((mutation, state) => {
    localStorage.setItem('dashboardConfig', JSON.stringify(state.dashboardConfig));
  });
}

export async function handleShortCode(shortCode) {
  const res = await axios.get(`getLocal10UrlFromShortCode?code=${shortCode}`);
  let url = res.data.url;
  window.location.replace(url);
}

export function getCookie(key) {
  let name = key + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
}

export function setCookie(key, value, expirationHours) {
  let date = new Date();
  date.setHours(date.getHours() + expirationHours);
  let expires = 'expires=' + date.toUTCString();
  document.cookie = key + '=' + value + ';' + expires + ';path=/';
}

export function deleteCookie(key) {
  document.cookie = key + '=;path=/';
}
